import { render, staticRenderFns } from "./HeroEditorDialog.vue?vue&type=template&id=45ce9449&scoped=true&"
import script from "./HeroEditorDialog.vue?vue&type=script&lang=js&"
export * from "./HeroEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./HeroEditorDialog.vue?vue&type=style&index=0&id=45ce9449&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce9449",
  null
  
)

export default component.exports